module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "所属省市",
      "value": _vm.row.county ? _vm.row.province + '/' + _vm.row.city + '/' + _vm.row.county : ''
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "类型",
      "value": _vm.row.kaojitype
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "单位",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "授权编号",
      "value": _vm.row.kaojiregist_code
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "场地面积",
      "value": _vm.row.chandimianji
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "拟注册运动员人数",
      "value": _vm.row.yundongyuanrenshu
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "单位地址",
      "value": _vm.row.county ? _vm.row.province + '/' + _vm.row.city + '/' + _vm.row.county : ''
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "详细地址",
      "value": _vm.row.address
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "场地照片"
    }
  }, _vm._l((_vm.row.changdipic), function(item) {
    return _c('a', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      staticStyle: {
        "max-height": "50px"
      },
      attrs: {
        "src": item.url
      }
    })])
  }), 0), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "执照"
    }
  }, _vm._l((_vm.row.zhizhaopic), function(item) {
    return _c('a', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      staticStyle: {
        "max-height": "50px"
      },
      attrs: {
        "src": item.url
      }
    })])
  }), 0)], 1), _vm._v(" "), _c('van-divider', [_vm._v("负责人信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "负责人姓名",
      "value": _vm.row.nickname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "负责人身份证号",
      "value": _vm.row.certificatenumber
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "负责人邮箱",
      "value": _vm.row.email
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "负责人手机",
      "value": _vm.row.phone
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("审核信息")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "现场验收图片"
    }
  }, _vm._l((_vm.row.kaoji_yanshoufile), function(item) {
    return _c('a', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      staticStyle: {
        "max-height": "50px"
      },
      attrs: {
        "src": item.url
      }
    })])
  }), 0), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "备案审核"
    }
  }, [(_vm.row.kaojiregist_status == 0) ? _c('div', [_vm._v("未提交")]) : (_vm.row.kaojiregist_status == 1) ? _c('div', [_vm._v("待审核")]) : (_vm.row.kaojiregist_status == 2) ? _c('div', [_vm._v("审核通过")]) : (_vm.row.kaojiregist_status == 3) ? _c('div', [_vm._v("审核失败")]) : (_vm.row.kaojiregist_status == 4) ? _c('div', [_vm._v("预审核div")]) : _vm._e()]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "加盟类型"
    }
  }, [(_vm.row.kaoji_jiameng_type == 0) ? _c('div', [_vm._v("未知")]) : (_vm.row.kaoji_jiameng_type == 1) ? _c('div', [_vm._v("老政策")]) : (_vm.row.kaoji_jiameng_type == 2) ? _c('div', [_vm._v("0元")]) : (_vm.row.kaoji_jiameng_type == 3) ? _c('div', [_vm._v("9800元")]) : (_vm.row.kaoji_jiameng_type == 4) ? _c('div', [_vm._v("12万元")]) : (_vm.row.kaoji_jiameng_type == 5) ? _c('div', [_vm._v("13.5万元")]) : _vm._e()]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "拒绝审核理由",
      "value": _vm.row.kaojiregist_status_des
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "器材购买金额",
      "value": _vm.row.kaoji_buyprice
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "到账情况备注",
      "value": _vm.row.kaoji_buynote
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81f18358","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/apps/qcxj/ExameCenterDetail.vue
// module id = 2527
// module chunks = 0